<template>
  <div class="app-container">
    <list ref="list" :can-price="$permission.canPrice()">
        <template slot="toolbar-right" v-if="$permission.canWrite()">
            <!-- <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button> -->
            <el-button type="primary" @click="onShiftInventory" icon="el-icon-plus">转领料单</el-button>
        </template>
        <template slot="column">
            <el-table-column label="操作" fixed="right" align="center" width="100">
                <template slot-scope="{row}">
                    <el-button v-if="$permission.canWrite() && row.Status !== 2" @click="edit(row)" type="text" >
                      编辑
                    </el-button>
                    <el-button v-if="$permission.canReview() && row.Status == 2"   type="text" @click="edit(row)">查看</el-button>
                </template>
            </el-table-column>
      </template>
    </list>
    <!-- <edit-dialog ref="editDialog"></edit-dialog> -->
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/business/stock/pdaproductionpicking/list'


export default {
  name: "bom",
  mixins: [curdMixins],
  components: { 
    list,
  },
  data(){
    return {
      api: require("@/api/pr/prGetDocLog").default,
    }
  },
  methods: {
    edit({DocId}){
      let id = DocId;
      this.api.info(id).then(res => {
        if(res.Code === 0){
          this.toURL({
            name: 'editpdaproductionpicking',
            params: {
              type: 'edit',
              data: res.Data
            }
          })
        }
        

      })
    },
    create(){
      
      this.toURL({
        name: 'editpdaproductionpicking',
        params: {
          type: 'create'
        }
      })

    },
    toURL(o){
      this.$router.push(o)
    },
    onShiftInventory() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要转入库单的数据");
        return;
      }
      this.$confirm("确认转入库单所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let ids = rows.map((item) => item.DocId);
        this.$refs.list.shiftInventory(ids);
      }).catch(() => { });
    }
  }
  
};
</script>